export default {
  getExercisesList() {
    return this.http(
      'ExerciseCheck',
      'get',
      'api/v1/exercises/nice_exercise.json'
    );
  }
};
